/**
 * Public URL helper.
 *
 * For QR codes, shareable links, referral URLs, OG previews, and any link that a
 * user might paste somewhere public, ALWAYS use the production-facing domain so
 * that previews from staging / preview environments don't leak Emergent URLs.
 *
 * Set REACT_APP_PUBLIC_URL in /app/frontend/.env. Falls back to bet4peer.com.
 */

const PUBLIC_URL = (process.env.REACT_APP_PUBLIC_URL || 'https://bet4peer.com').replace(/\/$/, '');

export function getPublicUrl(path = '/') {
    if (!path) path = '/';
    if (!path.startsWith('/')) path = '/' + path;
    return `${PUBLIC_URL}${path}`;
}

export function getPublicOrigin() {
    return PUBLIC_URL;
}
